import React from 'react'

// A failed check replaces the required marker so the label reads 'Question? — Required'.
const OptionLabel = ({ label, required, error }) => (
    <label className="form-label">{label}{error ? ' — Required' : (required ? '*' : '')}</label>
)

export const OptionButtons = ({ id, label, options, value, onChange, required, error }) => {
    return (
        <div className="input-wrapper flex-100">
            {label && <OptionLabel label={label} required={required} error={error} />}
            <div className="option-btns">
                {options.map((opt) => (
                    <span
                        key={opt.value}
                        className={`btn btn-select ${value === opt.value ? 'active' : ''}`}
                        onClick={() => onChange(id, value === opt.value ? '' : opt.value)}
                    >
                        {opt.label}
                    </span>
                ))}
            </div>
        </div>
    )
}

export const MultiOptionButtons = ({ id, label, options, value = [], onChange, required, error }) => {
    const toggle = (optValue) => {
        const current = value || []
        const idx = current.indexOf(optValue)
        const next = idx === -1
            ? [...current, optValue]
            : current.filter((v) => v !== optValue)
        onChange(id, next)
    }

    return (
        <div className="input-wrapper flex-100">
            {label && <OptionLabel label={label} required={required} error={error} />}
            <div className="option-btns">
                {options.map((opt) => (
                    <span
                        key={opt.value}
                        className={`btn btn-select ${(value || []).includes(opt.value) ? 'active' : ''}`}
                        onClick={() => toggle(opt.value)}
                    >
                        {opt.label}
                    </span>
                ))}
            </div>
        </div>
    )
}
